import React from 'react';

import { WebSocketContext } from 'providers';

export const useWebSocket = () => {
  return React.useContext(WebSocketContext);
};
